const types = [
  {
    title: "Manufacturing",
    mobile: true,
    desc: "Manufacturing and Assembling",
    speed: "Slow",
    icon: "/images/Expertise/manufacturing.jpg",
  },
  {
    title: "Financial Services",
    mobile: true,
    desc: "Payment Gateway and Micro Lending",
    speed: "Slow",
    icon: "/images/Expertise/onlinepayment.jpg.avif",
  },
  {
    title: "Trading",
    mobile: true,
    desc: "Sales and Distribution",
    speed: "Slow",
    icon: "/images/Expertise/sales.jpg.avif",
  },
  {
    title: "Logistics",
    mobile: true,
    desc: "Logistics and Transportation",
    speed: "Slow",
    icon: "/images/Expertise/delivery.jpg.avif",
  },
  {
    title: "eCommerce",
    mobile: true,
    desc: "Disrupting retail applications & software",
    speed: "Slow",
    icon: "/images/Expertise/ecommerce.jpg.avif",
  },
  {
    title: "Professional Services",
    mobile: true,
    desc: "real estate, tax consulting, consumer finance, and field sales monitoring and evaluation.",
    speed: "Slow",
    icon: "/images/Expertise/services.jpg.avif",
  },
];

// export function Expertise() {
//   return (
//     <div>
//       <h2 className="text-2xl font-semibold mb-6">Industry Expertise</h2>
//       <div className="grid md:grid-cols-3 gap-4">
//         {types.map((t, i) => (
//           <div
//             key={i}
//             className="bg-white p-4 rounded-xl shadow hover:shadow-lg transition"
//             style={{
//               backgroundImage: `url(${t.icon})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//             }}
//           >
//             <img
//               src={t.icon}
//               alt={t.title}
//               className="w-20 h-20 mx-auto mb-4"
//             />
//             <h3 className="text-lg text-black font-bold">{t.title}</h3>
//             <p className="text-sm text-black">{t.desc}</p>
//             {/* <p className="text-sm text-gray-400 mt-1">Delivery: {t.speed}</p> */}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

export function Expertise() {
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">Industry Expertise</h2>
      <div className="grid md:grid-cols-3 gap-6">
        {types.map((t, i) => (
          <div
            key={i}
            className="bg-white p-6 rounded-xl shadow hover:shadow-xl transition transform hover:scale-105 relative overflow-hidden group"
            style={{
              backgroundImage: `url(${t.icon})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* Initially showing the image */}
            <img
              src={t.icon}
              alt={t.title}
              className="w-20 h-20 mx-auto mb-4 transition-opacity duration-300 opacity-100 group-hover:opacity-0"
            />

            {/* Text content that appears on hover */}
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <h3 className="text-lg font-bold">{t.title}</h3>
              <p className="text-sm text-center">{t.desc}</p>
              {/* Uncomment if you want to display delivery speed */}
              {/* <p className="text-sm text-gray-300 mt-2">Delivery: {t.speed}</p> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
